import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate && navigate("/login");
  }, [navigate]);

  return <div></div>;
}

export default App;
